import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoCommsBusiness = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 206 30"
    {...props}
  >
    <path
      fill="#009FE3"
      d="M171.477 8.725h-5.866v4.244h4.468v3.972h-4.468v4.39h5.866v4.37h-10.594V4.306h10.594z"
    />
    <path
      fill="#010101"
      d="M11.867 10.119c0-1.548-.89-1.729-1.556-1.729-.698 0-1.583.181-1.583 1.728v9.757c0 1.575.857 1.756 1.584 1.756.726 0 1.555-.181 1.555-1.756v-1.638h4.756v1.484c0 3.694-2.597 6.272-6.312 6.272C6.598 25.993 4 23.422 4 19.728v-9.456C4 6.578 6.57 4 10.312 4c3.741 0 6.311 2.578 6.311 6.272v1.15h-4.756zM19.282 19.729V10.3c0-3.693 2.57-6.272 6.311-6.272s6.312 2.579 6.312 6.272v9.429c0 3.693-2.632 6.244-6.312 6.244s-6.311-2.544-6.311-6.244m4.728-9.575v9.728c0 1.547.891 1.728 1.583 1.728.542 0 1.556-.153 1.556-1.728v-9.728c0-1.575-.822-1.756-1.556-1.756-.733 0-1.583.18-1.583 1.756M39.895 16.154V25.7h-4.721V4.3h4.721l3.139 11.61L46.173 4.3H50.9v21.4h-4.728v-9.637l-1.584 6h-3.138zM59.24 16.154V25.7h-4.727V4.3h4.728l3.139 11.61L65.518 4.3h4.722v21.4h-4.722v-9.637l-1.583 6H60.79zM85.714 10.028h-4.66c0-1.394-.884-1.728-1.583-1.728-.7 0-1.46.425-1.46 1.33 0 3.15 7.929 4.398 7.929 10.454 0 3.61-2.508 5.909-6.408 5.909-3.899 0-6.434-2.516-6.434-6.216h4.721c0 1.484.98 1.79 1.74 1.79.761 0 1.556-.361 1.556-1.42 0-3.332-7.798-4.607-7.798-10.488C73.317 6.244 75.79 4 79.532 4c3.742 0 6.182 2.488 6.182 6.028"
    />
    <path
      fill="#009FE3"
      d="M89.825 4.307h5.866c3.708 0 6.312 1.575 6.312 5.575v1.15c0 1.846-.727 3.212-2.029 3.846 1.364.67 2.221 1.819 2.221 3.847v1.456c0 3.791-2.44 5.512-6.312 5.512h-6.058zm5.674 8.878c1.303 0 1.775-.244 1.775-1.61V10.3c0-1.276-.48-1.61-1.775-1.61h-.952v4.488h.953zm.192 8.18c1.302 0 1.775-.299 1.775-1.574v-1.366c0-1.303-.35-1.756-1.775-1.756h-1.144v4.697zM113.036 4.3h4.756v15.456c0 3.666-2.597 6.244-6.312 6.244-3.714 0-6.311-2.578-6.311-6.244V4.3h4.756v15.61c0 1.547.891 1.728 1.555 1.728.665 0 1.556-.181 1.556-1.728zM133.17 10.028h-4.66c0-1.394-.884-1.728-1.583-1.728s-1.46.425-1.46 1.33c0 3.15 7.929 4.398 7.929 10.454 0 3.61-2.508 5.909-6.408 5.909-3.899 0-6.434-2.516-6.434-6.216h4.721c0 1.484.98 1.79 1.748 1.79.767 0 1.555-.361 1.555-1.42 0-3.332-7.798-4.607-7.798-10.488C120.773 6.244 123.247 4 126.988 4s6.182 2.488 6.182 6.028M140.968 4.3h-4.721v21.394h4.721zM157.271 25.7h-4.502l-3.426-9.853V25.7h-4.756V4.3h4.502l3.426 10.063V4.3h4.756z"
    />
    <mask
      id="Logo_Comms_Business_svg__a"
      width={198}
      height={22}
      x={4}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M202 4H4v22h198z"
      />
    </mask>
    <g
      fill="#009FE3"
      mask="url(#Logo_Comms_Business_svg__a)"
    >
      <path
        d="M186.602 10.028h-4.66c0-1.394-.884-1.728-1.583-1.728s-1.46.425-1.46 1.33c0 3.15 7.929 4.398 7.929 10.454 0 3.61-2.508 5.909-6.408 5.909-3.899 0-6.435-2.516-6.435-6.216h4.722c0 1.484.98 1.79 1.748 1.79.767 0 1.555-.361 1.555-1.42 0-3.332-7.798-4.607-7.798-10.488C174.205 6.244 176.679 4 180.42 4s6.182 2.488 6.182 6.028M201.794 10.028h-4.66c0-1.394-.89-1.728-1.583-1.728-.692 0-1.459.425-1.459 1.33 0 3.15 7.928 4.398 7.928 10.454 0 3.61-2.501 5.909-6.407 5.909s-6.435-2.516-6.435-6.216h4.722c0 1.484.98 1.79 1.747 1.79s1.556-.361 1.556-1.42c0-3.332-7.799-4.607-7.799-10.488C189.391 6.244 191.865 4 195.606 4s6.182 2.488 6.182 6.028" />
    </g>
  </svg>
);
export default SvgLogoCommsBusiness;
